import { findNestedKey } from "helpers";

window.WYATT.storeAvailability ||= {};

class StoreAvailability {
  constructor() {
    this.promises = {}; // Responses are cached for life of page load. Clear this at a certain time interval??
  }

  async gettingAvailability(productId) {
    if (!this.promises[productId]) {
      this.promises[productId] = this.fetchAvailability(productId);
    }
    return this.promises[productId];
  }

  async fetchAvailability(productId) {
    try {
      const response = await fetch(
        `${window.WYATT.config.storeAvailability.endpoint}${productId}`,
      );
      const parsedResponse = await response.json();

      return this.getData(parsedResponse);
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error(error);
      throw error;
    }
  }

  getData(parsedResponse) {
    const data = {};

    const variants = findNestedKey(parsedResponse, "edges");

    variants.forEach((variant) => {
      const variantId = variant.node.id.replace(
        "gid://shopify/ProductVariant/",
        "",
      );
      const variantData = [];
      const availabilities = findNestedKey(variant, "inventoryLevels")?.edges;

      availabilities.forEach((availability) => {
        const { id, name, localPickupSettingsV2 } = findNestedKey(
          availability,
          "location",
        );
        const quantityAvailable = findNestedKey(availability, "quantity");

        variantData.push({
          id: JSON.parse(id.split("/Location/")[1]),
          localPickupSettingsV2,
          name,
          pickUpEnabled: window.WYATT.config.storeAvailability.enhanced
            ? !!localPickupSettingsV2
            : true,
          quantityAvailable,
        });
      });

      data[variantId] = variantData;
    });

    return data;
  }
}

window.WYATT.storeAvailability = new StoreAvailability();

export default { StoreAvailability };
